export const ProgramSourceTypes = {
    default: 0,
    fordIncentives: 1
}